<mat-icon *ngIf="icon" class="icon">{{ icon }}</mat-icon>
<input fxFlex type="text" [class.has-icon]="!!icon" readonly #inputElement>
<button *ngIf="buttonText || buttonIcon" mat-stroked-button (click)="copyInputMessage(inputElement)"
  [matTooltip]="'common.copyToClipboard' | translate">
  <span *ngIf="buttonText">{{ buttonText }}</span>
  <mat-icon *ngIf="!buttonText && buttonIcon">{{ buttonIcon }}</mat-icon>
</button>
